import { apiSlice } from './apiSlice';
import type { CreateHarvestRecordPayload, HarvestListResponse, HarvestRecord } from '../types/harvest';

export const harvestApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHarvestRecords: builder.query<HarvestListResponse, {
      farmId: string;
      from?: string;
      to?: string;
      cropId?: string;
      limit?: number;
      offset?: number;
    }>({
      query: (params) => ({
        url: '/harvest',
        method: 'GET',
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.records.map((r) => ({ type: 'HarvestRecord' as const, id: r.id })),
              { type: 'HarvestRecord', id: 'LIST' },
            ]
          : [{ type: 'HarvestRecord', id: 'LIST' }],
    }),
    createHarvestRecord: builder.mutation<HarvestRecord, CreateHarvestRecordPayload>({
      query: (body) => ({
        url: '/harvest',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'HarvestRecord', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetHarvestRecordsQuery,
  useCreateHarvestRecordMutation,
} = harvestApi;

export default harvestApi;
